export default __webpack_public_path__ + "static/media/mara-profile.233a930b.jpg";